import * as React from "react";
import { GridRowLessTwoBox } from "./styles";
import DoubleSwipe from "./doubleSwipe";

import { ProductCard } from "../../NormalProducts/ProductCard";

import { getCellWidthByGrid as getProductCardPosterWidth } from "../../../utils/size";
import { SwipeProductProps } from "../GridOne";
import { TProductElement } from "../../../../services/product";

interface SwipeProductState {
	cIndex: number;
	animationDuration: number;
	needAdd: number;
}

class SwipeProduct extends React.Component<SwipeProductProps, SwipeProductState> {
	productsOnOnePage: number = (this.props.gridCol || 4) * 2;

	state: SwipeProductState = {
		cIndex: 0,
		animationDuration: 0,
		needAdd: Math.ceil((this.productsOnOnePage * 3) / 2),
	};

	getOffset = () => {
		const { products } = this.props;
		return Math.floor(products.length / this.productsOnOnePage) * this.productsOnOnePage;
	};

	renderCard = (product: TProductElement, index: number) => {
		const {
			gridCol,
			gridGap,
			gridWidth: width,
			posterRatio,
			layoutStyle,
			placeholderBg,
			scoreOptions,
			smartImageProps,
			onClick,
			poolId,
		} = this.props;

		const productCardWidth = getProductCardPosterWidth({
			contentWidth: width,
			gridCol,
			gridGap,
		});
		return (
				<ProductCard
					key={index}
					product={{ ...product }}
					width={`${productCardWidth}px`}
					posterRatio={posterRatio}
					gridCol={gridCol}
					smartImageProps={smartImageProps}
					onClick={() => onClick && onClick((index + 1).toString(), product.gpid)}
					layoutStyle={layoutStyle}
					placeholderBg={placeholderBg}
					collectOptions={scoreOptions}
					poolId={poolId}
				/>
		);
	};

	render() {
		const {
			gridCol = 4,
			gridGap = 12,
			id,
			products,
			gridWidth,
			posterRatio,
			scoreOptions,
			handWheel,
			poolId,
		} = this.props;
		const productCardWidth = getProductCardPosterWidth({
			contentWidth: gridWidth,
			gridCol,
			gridGap,
		});
		const productCardPosterHight = +productCardWidth * +posterRatio;
		if (products.length <= this.productsOnOnePage) {
			return (
				<GridRowLessTwoBox
					posterHeight={productCardPosterHight}
					gridCol={gridCol}
					gridGap={gridGap}
					cardWidth={productCardWidth}
					gridWidth={gridWidth}
				>
					{products.map((product, index) => this.renderCard(product, index))}
				</GridRowLessTwoBox>
			);
		}

		return (
			<DoubleSwipe
				products={products}
				posterHeight={productCardPosterHight}
				gridCol={gridCol}
				gridGap={gridGap}
				cardWidth={productCardWidth}
				gridWidth={gridWidth}
				posterRatio={posterRatio}
				id={id}
				scoreOptions={scoreOptions}
				handWheel={handWheel}
				onClick={this.props.onClick}
				onClickBack={this.props.onClickBack}
				onClickNext={this.props.onClickNext}
				layoutStyle={this.props.layoutStyle}
				placeholderBg={this.props.placeholderBg}
				poolId={poolId}
			/>
		);
	}
}

export default SwipeProduct;
